// extracted by mini-css-extract-plugin
export default {"image":"SingleSelect_image__WQoLy","imageImg":"SingleSelect_imageImg__zBf-o","imagePh":"SingleSelect_imagePh__HppjE"};